import { render, staticRenderFns } from "./RedeemPage.vue?vue&type=template&id=0bb5ae2a&scoped=true&"
import script from "./RedeemPage.vue?vue&type=script&lang=js&"
export * from "./RedeemPage.vue?vue&type=script&lang=js&"
import style0 from "./RedeemPage.vue?vue&type=style&index=0&id=0bb5ae2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb5ae2a",
  null
  
)

export default component.exports